<template>
  <layout-default>
    <layout-introduction
      title="お問い合わせ"
      subtitle="Contact"
      :fullscreen="false"
    />
    <common-contact />
  </layout-default>
</template>

<style lang="scss" scoped>
  ul {
    margin: 12px 0 12px 32px;
  }
</style>

<script>
import LayoutDefault from '@/components/layouts/default/Layout';
import LayoutIntroduction from '@/components/layouts/common/Introduction';
import CommonContact from '../common/Contact';

export default {
  metaInfo: {
    title: 'Contact - Jerome Dupuis Portfolio'
  },
  methods: {
    isIranai(word) {
      return this.iranai.indexOf(word) > -1;
    }
  },
  components: {
    LayoutDefault,
    LayoutIntroduction,
    CommonContact
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/contact/Contact.vue